(function () {
    'use strict';

    /*
     * Copyright (c) 2019 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .constant('CampaignConstants', {
            save: {
                errorString: 'We were unable to create your campaign'
            },
            get: {
                errorString: 'We were unable to retrieve your campaign'
            },
            update: {
                errorString: 'We were unable to update your campaign'
            },
            remove: {
                confirmString: 'Are you sure you would like to delete this campaign?',
                errorString: 'We were unable to delete your campaign'
            },
            protocol: {
                remove: {
                    errorString: 'We were unable to remove the protocol'
                }
            },
            episodeTemplate: {
                get: {
                    errorString: 'We were unable to get the episode template'
                },
                getAll: {
                    errorString: 'We were unable to get the episode template'
                },
                remove: {
                    errorString: 'We were unable to delete the episode template',
                    confirmString: 'Are you sure you would like to delete this episode template?'
                }
            },
            campaignPrescriptions: {
                getAll: {
                    errorString: 'We were unable to get the campaign prescription'
                }
            },
            prescription: {
                getAll: {
                    errorString: 'We were unable to load the prescriptions'
                },
                remove: {
                    errorString: 'We were unable to remove the prescription',
                    confirmDialog: 'Are you sure you would like to remove the prescription'
                }
            },
            updateExpanded: {
                notice: 'Please finish what you are working on before expanding a new prescription.'
            },
            observers: {
                page: {
                    cancelEpisodeTemplate: 'therapist:CampaignGlanceCtrl:page:cancelEpisodeTemplate',
                    reset: 'therapist:CampaignGlanceCtrl:page:reset'
                },
                form: {
                    formReady: 'formReady'
                },
                glance: {
                    edit: 'therapist:CampaignGlanceCtrl:glance:edit',
                    cancel: 'therapist:CampaignGlanceCtrl:glance:cancel',
                    cancelPrescriptionCreation: 'therapist:CampaignGlanceCtrl:glance:cancelPrescriptionCreation',
                    save: 'therapist:CampaignGlanceCtrl:glance:save',
                    remove: 'therapist:CampaignGlanceCtrl:glance:remove'
                },
                prescription: {
                    edit: 'therapist:CampaignPrescriptionCtrl:prescription:edit',
                    cancel: 'therapist:CampaignPrescriptionCtrl:prescription:cancel',
                    save: 'therapist:CampaignPrescriptionCtrl:prescription:save',
                    remove: 'therapist:CampaignPrescriptionCtrl:prescription:remove',
                    quickAdd: 'therapist:CampaignPrescriptionCtrl:prescription:quickAdd',
                    quickAddWithIndex: 'therapist:CampaignPrescriptionCtrl:prescription:quickAddWithIndex',
                    updateProtocolDetails: 'therapist:CampaignPrescriptionCtrl:prescription:updateProtocolDetails'
                },
                expanded: {
                    collapseAll: 'therapist:CampaignPrescriptionCtrl:expanded:collapseAll'
                },
                prescriptions: {
                    reset: 'therapist:CampaignPrescriptionCtrl:prescription:remove'
                }
            },
            form: {
                campaignForm: 'campaignForm',
                campaignGlanceForm: 'campaignGlanceForm',
                campaignMessagesForm: 'campaignMessagesForm',
                campaignPrescriptionForm: 'campaignPrescriptionForm',
                campaignResourceMaterialsForm: 'campaignResourceMaterialsForm'
            },
            resources: {
                remove: {
                    errorString: 'We were unable to remove the resource material',
                    confirmText: 'Are you sure that you would like to remove this resource material?'
                }
            }
        });
})();